import { Text, View } from '@react-pdf/renderer';
import { type ReactElement } from 'react';
import { PDF_STYLES } from '../../styles';

const DATE_PLACEHOLDER = '____ / ____ / ____';

interface PatientConsentProps {
  title: string;
  statement: string;
  signatureLabel: string;
  dateLabel: string;
}

export const PatientConsent = ({
  title,
  statement,
  signatureLabel,
  dateLabel,
}: PatientConsentProps): ReactElement => (
  <View style={PDF_STYLES.consentSection}>
    <Text style={PDF_STYLES.consentTitle}>{title}</Text>
    <Text style={PDF_STYLES.consentStatement}>{statement}</Text>
    <View style={PDF_STYLES.consentSignatureRow}>
      <Text style={PDF_STYLES.consentMutedText}>{signatureLabel}</Text>
      <View style={PDF_STYLES.consentSignatureLine} />
    </View>
    <View style={PDF_STYLES.consentDateRow}>
      <Text style={PDF_STYLES.consentMutedText}>{dateLabel}</Text>
      <Text style={PDF_STYLES.consentMutedText}>{DATE_PLACEHOLDER}</Text>
    </View>
  </View>
);
